var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tabs',{ref:"mainTabs",attrs:{"size":"large","default-active-key":_vm.tabs[0].value,"nav-class":"main-tabs","tabBarStyle":{
      margin: 0,
      padding: '24px 24px 0 24px',
      background: '#ffffff',
    }},on:{"change":_vm.onChange}},_vm._l((_vm.tabs),function(ref){
    var label = ref.label;
    var value = ref.value;
return _c('a-tab-pane',{key:value,staticClass:"content-tab",attrs:{"tab":label}},[_vm._t(value)],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }